<template>
  <picture v-if="hasSourcesInternal">
    <source
      v-for="(source, index) in sourcesInternal"
      :key="index"
      v-bind="source"
    />

    <img
      :class="rootClass"
      v-bind="{ ...getAttrsAsInVue2($attrs), ...imgAttrs }"
      @load="onLoad($event)"
      @error="onError($event)"
    />
  </picture>

  <img
    v-else
    :class="rootClass"
    v-bind="{ ...$attrs, ...imgAttrs }"
    @load="onLoad($event)"
    @error="onError($event)"
  />
</template>

<script src="./scripts.js" />

<style module src="./styles.scss" lang="scss" />
